export * from "./relative-loader.component";
